export const TargetLink = Object.freeze({
  noLink: 'noLink',
  customerMainWebsite: 'customerMainWebsite',
  officeWebsite: 'officeWebsite',
  landingpagePerOffice: 'landingpagePerOffice',
  landingpage: 'landingpage',
  googleReview: 'googleReview',
  individualLink: 'individualLink',
})

type ValueOf<T> = T[keyof T]
export type TargetLinkType = ValueOf<typeof TargetLink>
